import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { fromEvent, Subject, takeUntil } from 'rxjs';
import { filter } from 'rxjs/operators';

@Directive({
  selector: '[modeNotebookResizeCells]',
})
export class NotebookResizeCellsDirective implements OnInit, OnDestroy {
  _destroyed$ = new Subject<void>();

  constructor(
    private _window: Window,
    private el: ElementRef
  ) {}

  ngOnInit() {
    fromEvent<MessageEvent>(this._window, 'message')
      .pipe(
        filter(
          (message: MessageEvent) =>
            message.data !== null && ['pythonResize', 'pythonClick'].indexOf(message.data.type) !== -1
        ),
        takeUntil(this._destroyed$)
      )
      .subscribe((message) => {
        const iframe = (this.el.nativeElement as HTMLElement).querySelector(
          `#mode-notebook-cell-result-${message.data.id}`
        ) as HTMLElement;

        if (message.data.type === 'pythonResize') {
          if (iframe) {
            iframe.style.height = `${message.data.height}px`;
            iframe.style.width = `${message.data.width}px`;
          }
        } else if (message.data.type === 'pythonClick') {
          // TODO: I'm not sure this is used as I can't find any references to this event in the repo
          // propogate click out of iframe
          iframe.dispatchEvent(new Event('mousedown'));
        }
      });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
